import axios from 'axios';
import Swal from "sweetalert2";
const instance = axios.create({
    baseURL: 'https://apisga.guilhermeviana.com/api/',
    timeout: 3600,
    token_type: 'bearer',
    headers: { 'X-Custom-Header': 'foobar' },
});

// Adiciona um interceptor para todas as requisições
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            // Define o token no header da requisição
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// Adiciona um interceptor para todas as respostas
 instance.interceptors.response.use(
    (response) => {
         return response;
   },
    (error) => {
        if (error.response.status === 401) {
            // Redireciona o usuário para a página de login
            Swal.fire({
                icon: 'warning',
                title: 'Tempo expirado!',
                text: 'Seu tempo de sessão acabou. Você será redirecionado para o login para revalidar eu tken de acessoo.',
                timer: 5000, // Define um tempo limite de 5 segundos (5000 milissegundos)
            }).then(() => {
                window.location.href = '/';
            });
            window.location.href = '/';
    }
        return Promise.reject(error);}
 );

export default instance;
